export const GET_ALL_AGENCIES = "GET_ALL_AGENCIES";

const agenciesGetters = {
  [GET_ALL_AGENCIES]: state => state.agencies
};

export default agenciesGetters;
